import { METRICTYPE } from 'src/utils/entityDefinitions';
import { TopicAdSummaryMetrics } from '../hooks/types';

export interface PaidSearchTopicCardDef {
  fieldId: keyof TopicAdSummaryMetrics;
  title: string;
  metricType: METRICTYPE;
  func?: 'avg' | 'sum' | 'last';
}

/**
 * Metric definitions for paid search topics
 */
export const paidSearchMetrics: readonly PaidSearchTopicCardDef[] = [
  { fieldId: 'adClicks', title: 'Ad Clicks', metricType: METRICTYPE.VOLUME },
  { fieldId: 'adSpend', title: 'Ad Spend', metricType: METRICTYPE.MONEY },
  { fieldId: 'adSales', title: 'Ad Sales', metricType: METRICTYPE.MONEY },
  {
    fieldId: 'adImpressions',
    title: 'Ad Impressions',
    metricType: METRICTYPE.VOLUME
  },
  {
    fieldId: 'cpc',
    title: 'CPC',
    metricType: METRICTYPE.MONEY,
    func: 'avg'
  },
  {
    fieldId: 'conversionRate',
    title: 'Conversion',
    metricType: METRICTYPE.PERCENT,
    func: 'avg'
  },
  {
    fieldId: 'ctr',
    title: 'CTR %',
    metricType: METRICTYPE.PERCENT,
    func: 'avg'
  },
  {
    fieldId: 'cpm',
    title: 'CPM',
    metricType: METRICTYPE.MONEY,
    func: 'avg'
  },
  {
    fieldId: 'adUnitsSold',
    title: 'Ad Units Sold',
    metricType: METRICTYPE.VOLUME
  },
  {
    fieldId: 'keywordCount',
    title: 'Keywords',
    metricType: METRICTYPE.VOLUME,
    func: 'last'
  },
  {
    fieldId: 'cpa',
    title: 'CPA',
    metricType: METRICTYPE.MONEY,
    func: 'avg'
  },
  {
    fieldId: 'roas',
    title: 'ROAS',
    metricType: METRICTYPE.MONEY,
    func: 'avg'
  }
] as PaidSearchTopicCardDef[];
